import { createSvgComponent } from "../../icon/createSvgComponent";
import Invite from "@core/icon/assets/invite.svg";
export default createSvgComponent(Invite);